import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaceholderImageCenter = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 288,
	height: 288,
	fill: "none",
	viewBox: "0 0 288 288",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 288,
			height: 288,
			fill: "#F2F2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D9D9D9",
			d: "M169.668 182H86.8966L120.678 120.532C123.692 115.049 131.549 114.991 134.643 120.429L169.668 182Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "white",
			d: "M202.135 181.999H169.668L156.111 157.929L165.118 141.446C168.125 135.943 176.007 135.882 179.099 141.339L202.135 181.999Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 187.508,
			cy: 99.3716,
			fill: "#D9D9D9",
			rx: 8.56258,
			ry: 8.62205
		})
	]
});
const ForwardRef = forwardRef(SvgPlaceholderImageCenter);
export default ForwardRef;
